import { useCallback, useEffect, useState } from "react"

import { getReports, toggleReportFavorite } from "../api/services.ts"
import type { ReportListItem } from "../types/types.ts"

export const useFavoriteReports = () => {
  const [reports, setReports] = useState<ReportListItem[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    void (async () => {
      const response = await getReports({ favorites: true })
      if (cancelled) return
      if (response.ok && Array.isArray(response.data))
        setReports(response.data as ReportListItem[])
      setLoading(false)
    })()
    return () => {
      cancelled = true
    }
  }, [])

  const unfavorite = useCallback(async (report: ReportListItem) => {
    setReports((prev) => prev.filter((item) => item.id !== report.id))
    const response = await toggleReportFavorite(report.id)
    if (!response.ok)
      setReports((prev) =>
        prev.some((item) => item.id === report.id) ? prev : [...prev, report]
      )
  }, [])

  return { reports, loading, unfavorite }
}
